export const DATE_TIME_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
    hourCycle: 'h24'
}

export const HTTP_STATUS = {
    OK: 200,
};

export const UTC_TIMEZONE_OFFSET_STRING = "Z";

export const ISO_STRING_YEAR_START_INDEX = 0;
export const ISO_STRING_YEAR_END_INDEX = 4;
export const ISO_STRING_MONTH_START_INDEX = 5;
export const ISO_STRING_MONTH_END_INDEX = 7;
export const ISO_STRING_DAY_START_INDEX = 8;
export const ISO_STRING_DAY_END_INDEX = 10;
export const ISO_STRING_TIME_START_INDEX = 11;
export const ISO_STRING_MINUTES_END_INDEX = 16;

export const DEFAULT_FLEX_COLUMN_NUMBER_OF_SENSOR = 3;

export const PAGE_HEADERS = {
    ASL_DEVICES: {
        head: "asl.heading",
        headAlt: "ASL Devices",
        desc: "asl.desc",
        descAlt: "This page shows the real-time status of ASL devices along with the device and ASL Guided Divert Configuration"
    },
    ADTA_DEVICES: {
        head: "adta.heading",
        headAlt: "ADTA Devices",
        desc: "adta.desc",
        descAlt: "This page shows the real-time status of ADTA devices along with the Sorter Destination and Sorter Test Package Configuration"
    },
    THIN_CLIENTS: {
        head: "thinclients.heading",
        headAlt: "Thin Clients",
        desc: "thinclient.desc",
        descAlt: "This page shows the real-time status of Thin Client devices along with the MAC/IP Address and health status"
    },
    SBL_DEVICES: {
        head: "sbl.heading",
        headAlt: "SBL Devices",
        desc: "sbl.desc",
        descAlt: "This page shows the real-time status of LED Controllers along with the MAC/IP Address and Connectivity"
    },
    DEVICE_MANAGEMENT: {
        head: "devicemanagement.heading",
        headAlt: "Device Management",
        desc: "devicemanagement.desc",
        descAlt: "This page shows the real-time status of Automation devices, Thin Clients and SBL devices and helps you to set configuration of the selected device type."
    },
    BAG_TRACKING: {
        tab: "bagtracking.tabHeading",
        tabAlt: "RFID Bag Tracking",
        head: "bagtracking.heading",
        headAlt: "Bag Tracking",
        desc: "bagtracking.description",
        descAlt: "This page shows tracking status of RFID Bags during the depart and receive process"
    }
}

export const OPERATIONS = {
    ADD: 'ADD',
    EDIT: 'EDIT',
    DELETE: 'DELETE',
    NO_OP: 'NO_OP'
}

export const OPERATION_COLOR = {
    ADD: '#c0f9bb',
    EDIT: '#bbe9f9',
    DELETE: '#f9bbbb',
    NO_OP: 'transparent'
}

export const STAGE = {
    PROD: 'PROD',
    GAMMA: 'GAMMA',
    BETA: 'BETA'
}

export const CONFIG_TYPE = {
    SORTER_DESTINATION: "SORTER_DESTINATION",
    SORTER_TEST_PACKAGE: "SORTER_TEST_PACKAGE",
    ADTF_SORTER_DESTINATION: "ADTF_SORTER_DESTINATION",
    ADTF_SORTER_TEST_PACKAGE: "ADTF_SORTER_TEST_PACKAGE",
    DIVERT_CONFIGURATION: "DIVERT_CONFIGURATION",
    LED_CONTROLLER_CONFIGURATION: "LED_CONTROLLER_CONFIGURATION",
    ZANCA_SORT_TEST_CONFIGURATION: "ZANCA_SORT_TEST_CONFIGURATION",
    ZANCA_SORT_LOCATION_CONFIGURATION: "ZANCA_SORT_LOCATION_CONFIGURATION",
    TESSERACT_TEST_CONFIGURATION: "TESSERACT_TEST_CONFIGURATION",
    TESSERACT_STOW_CONFIGURATION: "TESSERACT_STOW_CONFIGURATION",
    AUTO_RETRIEVER_TEST_CONFIGURATION: "AUTO_RETRIEVER_TEST_CONFIGURATION",
    AUTOLOADER_DESTINATION:"AUTOLOADER_DESTINATION",
    AUTOLOADER_TEST_PACKAGE: "AUTOLOADER_TEST_PACKAGE",
}

export const EVENT_TYPE = {
    MHE_LOG_DATA: "MHE_log_data"
}

export const CONFIG_TYPE_VALUE = {
    SORTER_DESTINATION: "Sorter Destination",
    SORTER_TEST_PACKAGE: "Sorter Test Package",
    ADTF_SORTER_DESTINATION: "Sorter Destination",
    ADTF_SORTER_TEST_PACKAGE: "Sorter Test Package",
    DIVERT_CONFIGURATION: "Guided Divert Configuration",
    LED_CONTROLLER_CONFIGURATION: "LED_CONTROLLER_CONFIGURATION",
    ZANCA_SORT_TEST_CONFIGURATION: "Stow Test Package",
    ZANCA_SORT_LOCATION_CONFIGURATION: "ZancaSort Locations",
    TESSERACT_TEST_CONFIGURATION: "Stow Test Package",
    TESSERACT_STOW_CONFIGURATION: "Stow Destination",
    AUTO_RETRIEVER_TEST_CONFIGURATION: "Pick Test",
    AUTOLOADER_DESTINATION:"AutoLoader Destination ",
    AUTOLOADER_TEST_PACKAGE: "AutoLoader Test Package",
}

export const TCP_PERMISSIONS = "tcpPermissions";
export const USER_LOGIN = "userLogin";
export const SPIDER_DEPLOYMENT_SERVICE = "spiderDeploymentService";

export const INSTALLATION_TYPES = {
    AISLE: {
        label: "Aisle",
        value: "aisle"
    },
    BULKY: {
        label: "Bulky",
        value: "bulky"
    },
    CLUSTER: {
        label: "Cluster",
        value: "cluster"
    },
    COLUMN: {
        label: "Column",
        value: "column"
    },
    FLOOR: {
        label: "Floor location",
        value: "floor"
    },
    JACKPOT: {
        label: "Jackpot",
        value: "jackpot"
    },
    OV: {
        label: "OV",
        value: "ov"
    },
    PROBLEM_SOLVE: {
        label: "Problem_Solve",
        value: "problem_solve"
    },
    RECIRCULATION: {
        label: "Recirculation",
        value: "recirculation"
    },
    SORT_ZONE: {
        label: "Sort Zone",
        value: "sort_zone"
    },
    Zone: {
        label: "Zone",
        value: "zone"
    },
    SIDELINE: {
        label: "SideLine",
        value: "sideline"
    },
    FRAGILE: {
        label: "Fragile",
        value: "fragile"
    },
    BIN: {
        label: "Bin",
        value: "bin"
    }
}

export const CATCH_ALL_INSTALLATION_TYPES = [
    INSTALLATION_TYPES.SIDELINE.value,
    INSTALLATION_TYPES.JACKPOT.value,
    INSTALLATION_TYPES.RECIRCULATION.value,
    INSTALLATION_TYPES.BULKY.value,
    INSTALLATION_TYPES.OV.value,
    INSTALLATION_TYPES.PROBLEM_SOLVE.value,
    INSTALLATION_TYPES.FRAGILE.value
]

export const ZANCASORT_LOCATION_TYPES = {
    WAREHOUSE_LOCATION: {
        label: "Warehouse Location",
        value: "WAREHOUSE_LOCATION"
    },
    PICK_LOCATION: {
        label: "Pick Location",
        value: "PICK_LOCATION"
    },
    STOW_LOCATION: {
        label: "Stow Location",
        value: "STOW_LOCATION"
    }
}

// NDMS Status values
export const ACTIVE = "ACTIVE"
export const INACTIVE = "INACTIVE"
export const DEPRECATED = "DEPRECATED"
export const CONNECTED = "Connected"
export const DISCONNECTED = "Disconnected"
export const REACHABLE = "Reachable"
export const UNREACHABLE = "Unreachable"
export const ONLINE_OK = "connected"
export const HEALTH_OK = "HEALTHY"

// GG software values
const GG_DEPLOYMENT_STATUS = {
    BUILDING: "Building",
    IN_PROGRESS: "InProgress",
    SUCCESS: "Success",
    FAILURE: "Failure",
    UNKNOWN: "UNKNOWN"
}
const GG_DEPLOYMENT_TYPE = {
    NEW: "NewDeployment",
    REDO: "Redeployment",
    RESET: "ResetDeployment",
    FORCE_RESET: "ForceResetDeployment"
}

// Portal software values
export const DEPLOYMENT_STATUS = {
    QUEUED: [GG_DEPLOYMENT_STATUS.BUILDING],
    IN_PROGRESS: [GG_DEPLOYMENT_STATUS.IN_PROGRESS, GG_DEPLOYMENT_STATUS.IN_PROGRESS],
    SUCCESS: [GG_DEPLOYMENT_STATUS.SUCCESS],
    FAILURE: [GG_DEPLOYMENT_STATUS.FAILURE, GG_DEPLOYMENT_STATUS.UNKNOWN]
}
export const DEPLOYMENT_TYPE = {
    DEPLOYMENT: [GG_DEPLOYMENT_TYPE.NEW, GG_DEPLOYMENT_TYPE.REDO],
    RESET: [GG_DEPLOYMENT_TYPE.RESET, GG_DEPLOYMENT_TYPE.FORCE_RESET]
}

export const SECONDARY = "Secondary"
export const PRIMARY = "Primary"

export const TRUE_VALUE = "true"
export const FALSE_VALUE = "false"

export const SCC_AUTOMATION_MANAGER = "AmazonFacility::SCC: Automation Manager";
export const SCC_AUTOMATION_VIEWER  = "AmazonFacility::SCC: Automation Viewer";

export const AMAZON_SUFFIX = "@amazon.com";
export const ZANCASORT_ASSET_TYPE = "ZANCASORT"
export const TESSERACT_ASSET_TYPE = "TESSERACT"
export const AUTO_LOADER_ASSET_TYPE = "AUTO_LOADER"
export const AUTO_RETRIEVER_ASSET_TYPE = "AUTO_RETRIEVER"
export const ADTA_ASSET_TYPE = "ADTA"
export const ADTA_DEVICE_INFO_KEY = "adtaDeviceInformation"
export const ADTF_ASSET_TYPE = "ADTF";
export const ADTF_MATRIX = "Matrix";
export const ADTF_SIMPLE = "Simple";
export const ADTF_PULLMODE = "PullMode";
export const ADTF_DEFAULT_DEVICE_ID = "1";
export const TRAFFIC_LIGHT_CONTROLLER_ASSET_TYPE = "TRAFFIC_LIGHT_CONTROLLER";
export const MODAL_SUCCESS = "SUCESS"
export const MODAL_ERROR = "ERROR"
export const MODAL_RESET = "RESET"
export const TRAFFIC_LIGHT_RESOURCE_TYPE = "TRAFFIC_LIGHT";
export const ASL_ASSET_TYPE = "ASL"
export const ASML_ASSET_TYPE = "ASML"
export const INDUCT_CAMERA_SUB_ASSET_TYPE = "INDUCT_CAMERA";
export const PRINTER_SUB_ASSET_TYPE = "PRINTER";
export const VERIFICATION_CAMERA_SUB_ASSET_TYPE = "VERIFICATION_CAMERA";
export const THIN_CLIENT_ASSET_TYPE = "EDGE_GATEWAY"
export const LIDAR_ASSET_TYPE = "LIDAR_CONTROLLER"
export const SBL_ASSET_TYPE = "sbl"
export const SBLV2_ASSET_TYPE = "health-monitoring"
export const IOT_AUTOMATION_ASSET_TYPE = "IOTAutomation"
export const MHE_AUTOMATION_ASSET_TYPE = "MHEAutomation"
export const IOT_AUTOMATION_ONLOGIC_ASSET_TYPE = "IOTAutomationOnLogic"
export const AUTOMATION_ASSET_TYPE = "automation"
export const AISLE_TYPE_CONFIG = "AISLE_TYPE"
export const LED_CONTROLLER_TYPE_CONFIG = "LED_CONTROLLER_TYPE"
export const LED_CONTROLLER_ASSET_TYPE = "LED_CONTROLLER"
export const DEFAULT_AISLE_TYPE = "Default"
export const AUTOMATION_TEXT = "Automation"
export const SBLV2_TEXT = "SBLv2"
export const SBLV3_TEXT = "SBLv3"
export const MAX_RETRIES = 6;
export const POLLING_INTERVAL = 5000; // 5 seconds
export const USE_CASE_MAP = {
    //displayText : visible to users
    //assetUseCase: stored in NARC asset attribute (health-monitoring, automation, IOTAutomationOnLogic)
    //useCase: useCase that NDMS accepts deploymentGroup (IOTAutomation, MHEAutomation, IOTAutomationOnLogic)
    [SBLV2_TEXT]: {
        displayText: SBLV2_TEXT,
        assetUseCase: SBLV2_ASSET_TYPE,
        useCase: IOT_AUTOMATION_ASSET_TYPE
    },
    [AUTOMATION_TEXT]: {
        displayText: AUTOMATION_TEXT,
        assetUseCase: AUTOMATION_ASSET_TYPE,
        useCase: MHE_AUTOMATION_ASSET_TYPE
    },
    [SBLV3_TEXT]: {
        displayText: SBLV3_TEXT,
        assetUseCase: IOT_AUTOMATION_ONLOGIC_ASSET_TYPE,
        useCase: IOT_AUTOMATION_ONLOGIC_ASSET_TYPE
    }
}
export const TAKA_CLIENT_LINK_PREFIX = "https://website.taka.fc.a2z.com/clients"
export const DEFAULT_VENDOR_ATTRIBUTES = {
    vendor: "",
    spec_version: "",
    sorter_type: "",
    hamper_vendor: "",
    hamper_version: ""
};

export const ERROR_METRIC_SUFFIX = "Error";
export const LOADING_FAILED = "Loading Failed!"
export const ALL_CONFIG = "ALL"
export const THREE_DOTS = "..."
export const ENDPOINT_AUTH = "/ndms/getAuthorization";
export const ENDPOINT_ADD_ASSET = "/ndms/addAsset";
export const ENDPOINT_ADD_ASSET_V2 = "/ndms/addAssetV2"
export const ENDPOINT_BATCH_UPDATE_ASSET_V2 = "/ndms/batchUpdateAssetV2"
export const ENDPOINT_UPDATE_ASSET = "/ndms/updateAsset";
export const ENDPOINT_UPDATE_ASSET_IN_PLACE = "/ndms/updateAssetInPlace";
export const ENDPOINT_SET_ASSET_STATUS = "/ndms/setAssetStatus";
export const ENDPOINT_GET_ASSET_BY_ASSET_TYPE = "/ndms/getAssets";
export const ENDPOINT_GET_ADTA_STATUS = "ndms/getADTAStatus";
export const ENDPOINT_GET_ADTF_STATUS = "ndms/getADTFStatus";
export const ENDPOINT_GET_ASL_STATUS = "ndms/getASLStatus";
export const ENDPOINT_GET_ASML_STATUS = "ndms/getASLStatus";
export const ENDPOINT_GET_DEVICE_HEALTH_STATUS = "/ndms/getDeviceHealthStatus";
export const RESPONSE_KEY_DATA = "data";
export const RESPONSE_KEY_DEVICE_HEALTH_STATUS_LIST = "deviceHealthStatusList";
export const ENDPOINT_GET_ASSET_BY_ASSET_LABEL = "/ndms/getAssetByAssetLabel"
export const ENDPOINT_GET_ASSET_VERSIONS = "/ndms/getAssetVersions"
export const ENDPOINT_GET_ASSET_BY_VERSION = "/ndms/getAssetByVersion"
export const ENDPOINT_GET_THIN_CLIENT_STATUS = "ndms/getThinClientStatus"
export const ENDPOINT_GET_SITE_DEVICES_CONNECTIVITY = "/ndms/getSiteDevicesConnectivity"
export const ENDPOINT_DEPLOY_THIN_CLIENT = "ndms/deployToThinClient"
export const ENDPOINT_GET_CORE_DEVICE_STATUS = "/greengrass/getCoreDeviceStatus/";
export const ENDPOINT_CREATE_REDEPLOYMENT = "/greengrass/redeployThing";
export const ENDPOINT_DELETE_THIN_CLIENT = "ndms/deleteThinClient"
export const ENDPOINT_PUBLISH_TRAFFIC_LIGHT_COMMAND_TO_THIN_CLIENT = "ndms/publishTrafficLightCommandToThinClient"
export const ENDPOINT_PUBLISH_COMMAND_TO_THIN_CLIENT = "ndms/publishCommandToThinClient";
export const ENDPOINT_SWITCH_OVER_THIN_CLIENT = "ndms/switchOverThinClient"
export const ENDPOINT_CHANGE_THIN_CLIENT_USECASE = "ndms/updateThinClientUseCase"
export const ENDPOINT_GET_THIN_CLIENT_DEPLOYMENT_STATUS = "ndms/getThinClientDeployment"
export const ENDPOINT_GET_LED_CONTROLLERS = "ndms/getLEDControllers";
export const ENDPOINT_UPDATE_LED_CONTROLLERS_REMARKS = "ndms/updateLedControllersRemarks"
export const ENDPOINT_SET_ASSET_DEFAULTS = "ndms/setAssetDefaults"
export const ENDPOINT_GET_ASSET_V2 = "ndms/getAssetV2"
export const ENDPOINT_UPDATE_DISABLE_MONITORING_SCHEDULE = "ndms/updateDisableMonitoringSchedule";
export const ENDPOINT_GET_SITE_ASSET_CONFIG = "ndms/getSiteAssetConfig"
export const ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT = "ndms/publishLightCommandToThinClient";
export const ENDPOINT_GET_MHE_VALIDATION = "/ndms/getMHEValidationData";
export const ENDPOINT_TRIGGER_MHE_VALIDATION = "ndms/triggerMHEValidation";
export const ENDPOINT_GET_PRESIGNED_URL_MHE_VALIDATION = "ndms/generatePresignedUrl";
export const ENDPOINT_GET_BAG_LOCATION_INFO = "/ndms/getBagLocationInfo";
export const PROCESS_NODE_RESOURCE = "nodeResource";
export const PROCESS_NODE_USER = "nodeUser";
export const ENDPOINT_GET_TCP_ROLES = "getTcpRoles";
export const ENDPOINT_GET_LIDAR_STATUS = "ndms/getLidarStatus";
export const ENDPOINT_GET_ASSETS_CONNECTIVITY = "ndms/getAssetConnectivity";
export const ENDPOINT_GET_MQTT_CONNECTION_DETAILS = "ndms/getMQTTConnectionDetails";
export const ENDPOINT_START_MOCK_TEST_FOR_AR = "ndms/triggerASRSMockTest";
export const ENDPOINT_GET_RESOURCE_DYNAMIC_ATTRIBUTES = "ndms/getResourceDynamicAttributes";
export const ENDPOINT_GET_CART_RECIPE_BY_CART_TYPE = "getCartRecipe";
export const TEN_SECONDS_LOADER_TIMER = 10000;
export const MONITORING_STATUS_LOADER_TIMER = 10000;
export const SOFTWARE_STATUS_LOADER_TIMER = 30000;
export const USECASE_STATUS_LOADER_TIMER = 30000;

// The time in minutes for which lidar tester is activated at a time.
export const LIDAR_TESTER_ACTIVATION_PERIOD_MINUTES = 5;

// The refresh time interval for activating Lidar tester events in Lidar service backend.
export const LIDAR_TESTER_ACTIVATION_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

// The time after which the stow detection event for a sensor is cleared from UI.
export const LIDAR_TESTER_EVENT_CLEAR_TIMER_MS = 2000;

export const MILLISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000;

export const SKYLARK_LIDAR_CONTROLLER = "Skylark";

export const LIDAR_TESTER = "LIDAR_TESTER";
export const PROVISION_REQUEST = "PROVISION_REQUEST";
export const SKYLARK_BRANCH_PROVISION_REQUEST = "SKYLARK_BRANCH_PROVISION_REQUEST";
export const SKYLARK_LEAF_PROVISION_REQUEST = "SKYLARK_LEAF_PROVISION_REQUEST";
export const SKYLARK_BRANCH_PROVISION_TIMEOUT_IN_SECONDS = 60;
export const SKYLARK_LEAF_PROVISION_TIMEOUT_IN_SECONDS = 60;
export const SKYLARK_BRANCH_PROVISION_DISPLAY_TIMEOUT_IN_SECONDS = 55;
export const BRANCH = "Branch";
export const LEAF = "Leaf";
export const AISLE = "AISLE";
export const EXPECTED = "Expected";
export const DETECTED = "Detected";
export const ON_STATE = "ON";
export const OFF_STATE = "OFF";
export const SENSOR_INDEX_ZERO = "0";
export const SENSOR_INDEX_ONE = "1";

export const EMPTY_STRING_PLACEHOLDER = "-"
export const UNDERSCORE = "_"
export const COMMA = ","
export const DOT = "."
export const EMPTY_STRING = ""
export const SEMI_COLON = ";";
export const COLON = ":";
export const TIMEOUT_STRING = "timeout"
export const SUCCESS_STRING = "success"
export const ERROR_STRING = "error"
export const IN_PROGRESS_STRING = "in-progress"
export const LOADING_STRING = "Loading"
export const ACTIONS_STRING = "...";

// Colors
export const BLUE_COLOR = "#077398"
export const ORANGE_COLOR = "#FF714D"
export const RED_COLOR = "#FF5C4D"
export const GREY_COLOR = "#213340"
export const SEARCH_ROW_COLOR = "#F0F1F2"
export const PRIMARY_TEXT_COLOUR = "primary"

/**
 * Standardized status colors for consistent UI experience across components
 * These colors ensure WCAG AA compliance for accessibility and maintain visual consistency
 */
export const STATUS_COLORS = {
    SUCCESS: {
        BACKGROUND: '#7EC55E', // Material Design Green 400 - used for all success states
        TEXT: '#FFFFFF'        // White text for proper contrast
    },
    ERROR: {
        BACKGROUND: '#F44336', // Material Design Red 500 - used for all error states  
        TEXT: '#FFFFFF'        // White text for proper contrast
    },
    WARNING: {
        BACKGROUND: '#FFC107', // Material Design Amber 500 - used for timeout/warning states
        TEXT: '#000000'        // Black text for proper contrast on amber background
    },
    INFO: {
        BACKGROUND: '#2196F3', // Material Design Blue 500 - used for in-progress/info states
        TEXT: '#FFFFFF'        // White text for proper contrast
    }
};

// Troubleshooting resources
export const TROUBLESHOOTING_URLS = {
    SKYLARK_PROVISIONING: 'https://w.amazon.com/bin/view/Last_Mile_Team/Smart-Station/Skylark/SkylarkProvisioningTroubleshootingGuide'
};

// Status message constants for better maintainability and i18n preparation
export const STATUS_MESSAGES = {
    BRANCH_SUCCESS: 'Branch Node Provisioning Successful for {count} Aisles',
    BRANCH_ERROR: 'Branch Node Mismatch - Total Aisles: {expected}, Detected Branch Nodes: {detected}. <a href="' + TROUBLESHOOTING_URLS.SKYLARK_PROVISIONING + '" target="_blank" rel="noopener noreferrer">Troubleshooting Guide</a>',
    BRANCH_TIMEOUT: 'Provisioning Timeout - No Provisioning Response Received',
    LEAF_SUCCESS: 'Leaf Provisioning Successful - All Leaf Nodes are Detected',
    LEAF_ERROR: 'Mismatch between expected and detected Leaf Nodes. Check aisle configuration and cable connections. <a href="' + TROUBLESHOOTING_URLS.SKYLARK_PROVISIONING + '" target="_blank" rel="noopener noreferrer">Troubleshooting Guide</a>',
    LEAF_TIMEOUT: 'Leaf Provisioning Timeout - No Response Received from Leaf Nodes. <a href="' + TROUBLESHOOTING_URLS.SKYLARK_PROVISIONING + '" target="_blank" rel="noopener noreferrer">View Troubleshooting Guide</a>',
    LEAF_IN_PROGRESS: 'Leaf Provisioning in Progress'
};

export const SKYLARK_PROVISIONING_ACTIONS = {
    INIT_PROVISIONING: "INIT_PROVISIONING",
    SET_CLUSTER_STATUS: "SET_CLUSTER_STATUS",
    RESET_PROVISIONING: "RESET_PROVISIONING",
    UPDATE_PROVISIONING_DATA: "UPDATE_PROVISIONING_DATA"
}

export const MHE_VALIDATION_STATUS_TYPE = {
    COMPLETED: "COMPLETED",
    ERROR: "ERROR",
    IN_QUEUE: "IN_QUEUE",
    IN_PROGRESS: "IN_PROGRESS",
}

export const MHE_VALIDATION_RESULT_TYPE = {
    PASS: "PASS",
    FAIL: "FAIL",
    WARN: "WARN"
}

export const MHE_VALIDATION_STATUS_COLORS = {
    COMPLETED: BLUE_COLOR,
    IN_QUEUE: GREY_COLOR,
    IN_PROGRESS: GREY_COLOR,
    ERROR: ORANGE_COLOR
}

export const MHE_VALIDATION_RESULT_COLORS = {
    PASS: BLUE_COLOR,
    FAIL: RED_COLOR,
    WARN: ORANGE_COLOR
}

// sort directions
export const ASCENDING = "ascending";
export const DESCENDING = "descending";

export const ALERT_ASSET_STATUS_MESSAGE = "Failed to update Asset Status to Active. Try again!"
export const ALERT_ASSET_USE_CASE_UPDATE = "Failed to update Asset Use Case to Primary. Try again!"
export const ALERT_ASSET_USE_CASE_CHANGE = "Failed to change Thin Client use case. Try again!"
export const ALERT_START_AR_MOCK_TEST = "Failed to start mock test. Try again!"
export const ALERT_ASSET_DEPLOY_MESSAGE = "Failed to deploy Asset. Try again!"
export const ALERT_ADD_ASSET_MESSAGE = "Failed while adding asset. Try again!"
export const ALERT_RESTART_APPLICATION_FAILED = "Failed to restart application.";
export const ALERT_UPDATE_ASSET_MESSAGE = "alert.asset_details_fail"
export const ALERT_DELETE_ASSET_MESSAGE = "alert.asset_delete_fail"
export const ALERT_UPDATE_ASSET_DEFAULTS_MESSAGE = "alert.asset_defaults_fail"
export const ALERT_PUBLISH_TRAFFIC_LIGHT_COMMAND_MESSAGE = "Failed while publishing traffic light command. Try again!"
export const ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET = "Failed to update asset details as same MAC Address already exists. Recheck the MAC Address with RME and try again!"
export const ALERT_UPDATE_SUCCESS_ASSET_MESSAGE = "alert.asset_details_success"
export const ALERT_CREATE_SUCCESS_ASSET_MESSAGE = "alert.asset_create_success"
export const ALERT_PAGE_REFRESH_MESSAGE = " Please note that it may take few seconds for the latest data to appear. The page will refresh automatically once data is available."
export const ALERT_DELETE_SUCCESS_ASSET_MESSAGE = "alert.asset_delete_success"
export const ALERT_UPDATE_SUCCESS_ASSET_DEFAULTS_MESSAGE = "alert.asset_defaults_success"
export const ALERT_MHE_VALIDATION_FAILED_MESSAGE = "New Validation could not be created because a validation in the selected time frame already exists or another validation is currently in progress."
export const ALERT_MHE_VALIDATION_REPORT_DOES_NOT_EXIST = "MHE Validation report does not exist." +
    " Please reach out to the UTR team for resolution."

export const getUpdateAssetMessageAlertWithSite = (nodeId) => {
    return `Failed to update asset details as same MAC Address already exists for Site : ${nodeId}. Recheck the MAC Address with RME and try again!`;
}

export const MAX_CSV_SIZE_BYTES = "358400" // 350kbs
export const RESTART_APPLICATION_STATUS_TIMEOUT = 120000;

export const MARKETPLACE_LOCALE_MAP = {
    de: ["de", "de-DE", "de-CH", "de-AT", "de-LU", "de-LI"],
    es: ["es", "es-ES", "es-AR", "es-GT", "es-CR", "es-PA", "es-DO", "es-MX", "es-VE", "es-CO",
        "es-PE", "es-EC", "es-CL", "es-UY", "es-PY", "es-BO", "es-SV", "es-HN", "es-NI", "es-PR"],
    ja: ["ja", "ja-JP"],
    it: ["it", "it-IT", "it-CH"],
    fr: ["fr", "fr-FR", "fr-BE", "fr-CA", "fr-CH", "fr-LU"],
    ar: ["ar", "ar-SA", "ar-IQ", "ar-EG", "ar-LY", "ar-DZ", "ar-MA", "ar-TN", "ar-OM", "ar-YE",
        "ar-SY", "ar-JO", "ar-LB", "ar-KW", "ar-AE", "ar-BH", "ar-QA"],
    en: ["en"]
}

// Health status display values
export const HEALTH_STATUS = {
    HEALTHY: {
        string: "Healthy",
        color: BLUE_COLOR
    },
    DISCONNECTED: {
        string: "Disconnected",
        color: ORANGE_COLOR
    },
    UNHEALTHY: {
        string: "Unhealthy",
        color: ORANGE_COLOR
    },
    LOADING: {
        string: "Loading...",
        color: GREY_COLOR
    },
    LOADING_FAILED: {
        string: "Loading failed",
        color: ORANGE_COLOR
    }
}

// Health status display values
export const SW_STATUS = {
    QUEUED: {
        string: "Deployment is Queued",
        color : BLUE_COLOR
    },
    RESTARTED: {
        string: "Application Restarted",
        color: BLUE_COLOR
    },
    RESTART_IN_PROGRESS: {
        string: "Restart Application in progress",
        color: BLUE_COLOR
    },
    DEPLOYED: {
        string: "Deployed",
        color: BLUE_COLOR
    },
    DEPLOYMENT_IN_PROGRESS: {
        string: "Deployment in progress",
        color: BLUE_COLOR
    },
    RESET_IN_PROGRESS: {
        string: "Reset in progress",
        color: BLUE_COLOR
    },
    CLEAN: {
        string: "Clean",
        color: GREY_COLOR
    },
    LOADING: {
        string: "Loading...",
        color: GREY_COLOR
    },
    ERROR: {
        string: "Error",
        color: ORANGE_COLOR
    },
    LOADING_FAILED: {
        string: "Loading failed",
        color: ORANGE_COLOR
    }
}

export const EXTERNAL_LINKS = [
    {
        id: "external.dashboard",
        links: {
            NA: "https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/Runbook/StationDashboards/NA",
            EU: "https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/Runbook/StationDashboards/EU",
            FE: "https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/Runbook/StationDashboards/FE"
        }
    }, {
        id: "external.logs",
        links: {
            NA: "https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/LogDashboard/NA",
            EU: "https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/LogDashboard/EU",
            FE: "https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/LogDashboard/FE"
        }
    }
]

export const MCM = "MCM";
export const TICKET = "Ticket";
export const JUSTIFICATION = "Justification";
export const MCM_AMAZON = "mcm.amazon";
export const TCORP_AMAZON = "t.corp.amazon";

export const MAX_LOGS_COUNT = 300;
export const WSS = "wss";
export const AUTOMATION_MQTT_TOPIC_PREFIX = "site/";
export const AUTOMATION_MQTT_TOPIC_SUFFIX = "/events";
export const LOGS = "logs";
export const MAX_RECONNECT = 5;
export const MQTT_CONNECTION_DETAILS_EXPIRY_TIMEOUT = 60000;
export const MAX_MQTT_RECONNECTION_TIME = 2000;

export const MQTT_ENDPOINT = {
    BETA: {
        NA: "a1tgwyzzinp1f0-ats.iot.us-east-1.amazonaws.com"
    },
    GAMMA: {
        NA: "af9drbwk8uihp-ats.iot.us-east-1.amazonaws.com",
        EU: "a3jy8lc7laf3c-ats.iot.eu-west-1.amazonaws.com",
        FE: "a1r90n03mcgh1o-ats.iot.us-west-2.amazonaws.com"
    },
    PROD: {
        NA: "a2o3z9qovyp9aq-ats.iot.us-east-1.amazonaws.com",
        EU: "a3hm32ps5qiz7a-ats.iot.eu-west-1.amazonaws.com",
        FE: "a2qxo5h7xpeqx2-ats.iot.us-west-2.amazonaws.com"
    }
}

export const AWS_REGION = {
    NA: "us-east-1",
    EU: "eu-west-1",
    FE: "us-west-2"
}

export const MERIDIAN_ALERT_TYPE = {
    INFO: "informational",
    ERROR: "error",
    WARN: "warning",
    SUCCESS: "success"
}

export const DEVICE_TYPE_RENDER_STRING = {
    LIDAR_CONTROLLER: "Lidar Controllers",
    BRANCH_NODE: "Aisle Controllers",
    LEAF_NODE: "Column Controllers",
    LIDAR_SENSOR: "Lidar Sensors"
}

export const DEVICE_TYPE = {LIDAR_CONTROLLER: "LIDAR_CONTROLLER",
    BRANCH_NODE: "BRANCH_NODE",
    LEAF_NODE: "LEAF_NODE",
    LIDAR_SENSOR: "LIDAR_SENSOR"
}

export const EU_OV_LOCATION_LABEL_REGEX = new RegExp("OVER-[A-Z]\\d*-[A-Z]");
export const NA_OV_LOCATION_LABEL_REGEX = new RegExp("OV-([A-Z]\\d*)-([A-Z]+$)");
export const EU_OV_LOCATION_LABEL_REGEX_WITH_OVD= new RegExp("[A-Z]\\d*-[M-UW-Z]");
export const NA_OV_LOCATION_LABEL_REGEX_WITH_OVD    = new RegExp("[A-Z]-\\d*\\.[M-UW-Z]");

export const MAC_ADDRESS_PREFIX = "MAC_ADDRESS:";
export const UNASSIGN_PRINTER = "UNASSIGN PRINTER";
export const UNASSIGN_VERIFICATION_CAMERA = "UNASSIGN VERIFICATION CAMERA";

export const NO_PRINTER_ASSIGNED = "NO PRINTER ASSIGNED";
export const NO_VERIFICATION_CAMERA_ASSIGNED = "NO VERIFICATION CAMERA ASSIGNED";

export const BAG_TRACKING_ALLOWED_STATIONS = ["DJR5"];

export const AUTO_LOADER_ASSET_ENABLED_STATIONS= ["TST2"];

export const BAG_TRACKING_CONSTANTS = {
    RECEIVE: "RECEIVE",
    DEPART: "DEPART",
    INSIDE_STATION: "Inside Station",
    OUTSIDE_STATION: "Outside Station",
    RECEIVE_TIME: "RECEIVE_TIME",
    DEPART_TIME: "DEPART_TIME"
}

// Constant containing lidar sensor state values
export const LIDAR_TESTER_SENSOR_STATES = {
    DEFAULT: 1,
    STOW_DETECTED: 2
}

export const LOCATION_MAPPING_ATTR = {
    LEAF_NODE_INDEX: "LEAF_NODE_INDEX",
    LIDAR_SENSOR_INDEX: "LIDAR_SENSOR_INDEX"
}

/**
 * API key and account Id for Pendo
 */
export const ANALYTICS_CONFIG = {
    PENDO_AK: "ae299fdb-5276-403c-4b78-dd8b69d722d7",
    ACCOUNT_ID: "SCC - AMZL"
};

export const DELETE_DEVICE_EXCLUDED_ASSET_TYPES = [
    /**
     * Excluded this asset type as LED Controller data is fetched from IoT Core, which is eventually consistent and
     * may not reflect deletions immediately. The logic is handled separately in the Network API with a retry mechanism.
     */
    LED_CONTROLLER_ASSET_TYPE

    // Add other excluded asset types here
];

/**
 * Visual styling colors for different column types
 * Priority order: FLEX > UNIFIED_OV > REGULAR
 */
export const LIDAR_COLUMN_COLORS = {
    FLEX: '#D8F2EA',        // Soft minty green for flex columns
    UNIFIED_OV: '#D0E1FF',  // Light blue for unified OV columns  
    REGULAR: '#fff',        // White for regular columns
    ANOMALY: '#000'         // Black for anomaly/error state
};

/**
 * Column dimensions
 */
export const LIDAR_COLUMN_DIMENSIONS = {
    WIDE_WIDTH: '140px',    // For multi-character or OV columns
    NARROW_WIDTH: '70px',   // For single character columns
    BORDER: '0.5px solid black'  // Standard border
};

// LED Controller (STAG) constants
export const CART_RESOURCE_TYPE = "CART";
export const DEFAULT_PERCENTILE = 30;
export const LOW_BATTERY_THRESHOLD = 30;
export const DEFAULT_ANDON_COLOR_HEX = "#D13212";
export const NEUTRAL_COLOR_HEX = "#000000";
export const SBL_DASHBOARD_METRIC_PROCESS_NAME = "SBL_DASHBOARD";
export const METRIC_GET_RESOURCE_DYNAMIC_ATTRIBUTES = "getResourceDynamicAttributes";
export const RESOURCE_DYNAMIC_ATTRIBUTES_KEY = "resourceDynamicAttributes";
export const DEFAULT_DURATION = 10;
export const DEFAULT_SORT_COLUMN = "scannableId";
export const LIGHT_COMMAND_ON = "ON";
export const LIGHT_COMMAND_OFF = "OFF";
export const ANDON_PROCESS_NAME = "SBL_ANDON";
export const METRIC_PUBLISH_LIGHT_COMMAND = "publishLightCommand";
// Max concurrent requests per batch to avoid throttling the publishLightCommand API.
// TODO: Confirm TPS limit with the thin client backend team and adjust accordingly.
export const DEFAULT_ANDON_BATCH_SIZE = 10;
export const BATTERY_COLUMN = "battery";
export const PROMISE_FULFILLED = "fulfilled";

export const SBL_DASHBOARD_ACTIONS = {
    LOAD_VIEW: "LOAD_VIEW",
    RECEIVE_CONFIG: "RECEIVE_CONFIG",
    RECEIVE_DATA: "RECEIVE_DATA",
    RECEIVE_ERROR: "RECEIVE_ERROR",
    SORT_DATA: "SORT_DATA"
};

export const ANDON_COLORS = [
    {value: "RED", label: "Red", hex: "#D13212"},
    {value: "YELLOW", label: "Yellow", hex: "#F2B705"},
    {value: "GREEN", label: "Green", hex: "#1D8102"},
    {value: "BLUE", label: "Blue", hex: "#0073BB"},
    {value: "WHITE", label: "White", hex: "#FFFFFF"}
];

export const TIMER_OPTIONS = [
    {value: 5, label: "5 minutes"},
    {value: 10, label: "10 minutes"},
    {value: 15, label: "15 minutes"},
    {value: 30, label: "30 minutes"},
    {value: 60, label: "60 minutes"}
];

// CartFilterPanel constants
export const CART_FILTER_PANEL_STRINGS = {
    SHOWING_BOTTOM: "cartFilter.showingBottom",
    SHOWING_BOTTOM_DEFAULT: "Showing Bottom {threshold}% — Click to Show All",
    SHOW_ALL: "cartFilter.showAll",
    SHOW_ALL_DEFAULT: "Show All Carts",
    SELECT_BOTTOM: "cartFilter.selectBottom",
    SELECT_BOTTOM_DEFAULT: "Filter carts to charge",
    CART_COUNT_FILTERED: "cartFilter.cartCountFiltered",
    CART_COUNT_FILTERED_DEFAULT: "{matchCount} of {totalCount} carts match",
    CART_COUNT: "cartFilter.cartCount",
    CART_COUNT_DEFAULT: "{matchCount} of {totalCount} carts",
    PERCENTILE_THRESHOLD: "cartFilter.percentileThreshold",
    PERCENTILE_THRESHOLD_DEFAULT: "Percentile threshold configured at station level: {threshold}%",
    TOGGLE_FILTER_ARIA: "cartFilter.toggleFilterAria",
    TOGGLE_FILTER_ARIA_DEFAULT: "Toggle bottom percentile cart filter"
};



// WEBPACK FOOTER //
// ./src/components/util/Constants.js